import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import MonthYearPicker from "../../../../components/MonthYearPicker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const FiltroRelatorioCapacidade = ({ handleDadosRelatorioCapacidade, projetos, date }) => {

    //States
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());

    // Função para obter o último dia do mês
    const getLastDayOfMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    };

    // Função para verificar se é dia 1 e atualizar o período final
    const handleInitialDateChange = (selectedDate) => {
        setInitialDate(selectedDate);
        
        // Se o argumento date foi passado e o dia selecionado é 1
        if (date && selectedDate.getDate() === 1) {
            const lastDayOfMonth = getLastDayOfMonth(selectedDate);
            setFinalDate(lastDayOfMonth);
        }
    };

    return (
        <>
            <Form className="mt-3">
                <div className='d-flex'>
                    <Form.Group className='d-flex flex-column mr-3'>
                        <Form.Label>Período inicial: </Form.Label>
                        {date ? <DatePicker
                            selected={initialDate}
                            onChange={handleInitialDateChange}
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            placeholderText="Selecione a data"
                            required
                        />
                            :
                            <MonthYearPicker
                                setMonthYear={setInitialDate}
                                monthYear={initialDate}
                            />}
                    </Form.Group>
                    <Form.Group className='d-flex flex-column mr-3'>
                        <Form.Label>Período final: </Form.Label>
                        {date ? <DatePicker
                            selected={finalDate}
                            onChange={setFinalDate}
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            placeholderText="Selecione a data"
                            required
                        />
                            :
                            <MonthYearPicker
                                setMonthYear={setFinalDate}
                                monthYear={finalDate}
                            />}
                    </Form.Group>
                </div>
            </Form>
            <Button onClick={() => handleDadosRelatorioCapacidade(initialDate, finalDate, projetos)}>Gerar</Button>
        </>
    )

}
export default FiltroRelatorioCapacidade